import { render } from "./news-link.vue?vue&type=template&id=35c65bda"
import script from "./news-link.vue?vue&type=script&lang=js"
export * from "./news-link.vue?vue&type=script&lang=js"

import "./news-link.vue?vue&type=style&index=0&id=35c65bda&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__